<template>
  <SettingsContainerDiv type="inner" :isSession="true">
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="layout.title"
      :isSession="true"
      :description="layout.description"
      :isSelect="true"
      :selectOptions="layout.options"
      :currentSelection="layout.current"
      @selected="updatePreference('layout', false, $event)"
    >
    </SettingArea>
    <SettingArea
      :comingSoon="false"
      :isEnabled="chatOpen.enabled"
      :title="chatOpen.title"
      :isSession="true"
      :description="chatOpen.description"
      @toggled="updatePreference('chatOpen', true, $event)"
    >
    </SettingArea>
    <SettingArea
      :comingSoon="false"
      :isEnabled="chatSound.enabled"
      :title="chatSound.title"
      :isSession="true"
      :description="chatSound.description"
      @toggled="updatePreference('chatSound', true, $event)"
    >
    </SettingArea>
  </SettingsContainerDiv>
</template>

<script>
import { mapState } from "vuex";
import SettingArea from "../../../../BookingPages/Settings/BaseComponents/SettingArea";
import SettingsContainerDiv from "../../../../BookingPages/Settings/BaseComponents/SettingsContainerDiv";
import { setDefaultLayout } from "../../SessionHelpers/layout";

export default {
  name: "SettingsGeneral",
  data() {
    return {
      layout: {
        title: "Default layout",
        description: "Set your default preferred layout.",
        options: [
          { label: "Partner view", value: "default" },
          { label: "Split view", value: "split" },
          { label: "Self view", value: "self" },
          // { label: "Full screen partner", value: "full" },
        ],
        current: null,
      },
      chatOpen: {
        title: "Chat open",
        description: "Control whether your chat is open or closed by default when you join the session.",
        enabled: false,
      },
      chatSound: {
        title: "Chat sound",
        description: "Choose whether you hear a sound when your partner sends you a message while you're in another tab or your chat is closed.",
        enabled: false,
      },
    };
  },
  components: {
    SettingArea,
    SettingsContainerDiv,
  },
  computed: {
    ...mapState({
      sessionPreferences: (state) => state.room.sessionPreferences,
    }),
  },
  mounted() {
    this.setCurrentGeneralSettings();
  },
  methods: {
    setCurrentGeneralSettings() {
      const preferences = this.sessionPreferences;

      this.layout.current = preferences.layout || "default";
      this.chatOpen.enabled = preferences.chatOpen;
      this.chatSound.enabled = preferences.chatSound;
    },
    async updatePreference(preference, isToggle, newValue) {
      if (!preference || (!newValue && newValue !== false)) {
        return console.warn("missing preference type or newValue");
      }

      /* 1. Update Vuex preferences */
      const updateData = { field: preference, newValue };
      await this.$store.dispatch("room/updatePreferenceField", updateData);

      /* 2. Update current in passed options */
      if (isToggle) {
        this[preference].enabled = newValue;
      } else {
        this[preference].current = newValue;
      }

      /* 3. Toggle if layout */
      if (preference == "layout") {
        setDefaultLayout();
      }
    },
  },
};
</script>